// lib/Image/lib/actionHandler.ts
var e = ({ editor: e, api: t }) => {
	let n = document.createElement("input");
	return n.accept = "image/jpg, image/gif, image/png", n.setAttribute("type", "file"), n.setAttribute("multiple", "multiple"), n.addEventListener("change", (r) => {
		let i = r;
		i.target.files?.length && t.consumeFileInputChangeEvent(e, i), setTimeout(() => {
			n = void 0;
		}, 0);
	}), n.click(), !0;
};
export { e as actionHandler };
